import React, { FunctionComponent } from 'react';
import * as Styled from './styled';

export interface TimeInputProps {
  disabled?: boolean;
  value?: string;
  onChange?: (e: any) => void;
}

export const TimeInput: FunctionComponent<TimeInputProps> = ({ value, disabled, onChange }) => {
  return <Styled.Time value={value} type="time" step="1" required onChange={onChange} disabled={disabled} />;
};

export default TimeInput;
